import { Component, Input, OnInit, inject } from '@angular/core';
import { AssortmentBannerService } from '../../../service/assortment.banner.service';
import { AssortmentBanner } from './assortment.banner';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'assortment-banner',
    templateUrl: 'assortment.banner.component.html',
    styleUrls: ['./assortment.banner.component.scss'],
    standalone: true,
    imports: [NgStyle],
})
export class AssortmentBannerComponent implements OnInit {
    private assortmentBannerService = inject(AssortmentBannerService);

    banner: AssortmentBanner;
    @Input() productIndex: number;
    @Input() bannerInterval: number;

    ngOnInit(): void {
        this.banner = this.assortmentBannerService.getBanner();
    }

    getTitle(): string {
        return this.banner.title;
    }

    getImageSrc(): string {
        return this.banner.imageUrl;
    }

    getBannerUrl(): string {
        return this.banner.bannerUrl;
    }

    getContentHeader(): string {
        return this.banner.contentHeader;
    }

    getContentHeaderStyle(): Record<string, string> {
        return {
            color: this.banner.contentColor,
            textShadow: this.getTextShadowColor(),
        };
    }

    getContent(): string {
        return this.banner.content;
    }

    getContentColor(): string {
        return this.banner.contentColor;
    }

    getTextShadowColor(): string {
        return this.banner.textShadow ? '0 0 4px rgba(0, 0, 0, 0.15)' : 'none';
    }

    getBannerContentStyle() {
        return {
            color: this.getContentColor(),
            textShadow: this.getTextShadowColor(),
        };
    }

    /**
     * Content style for the optional button.
     */
    getButtonContentStyle() {
        if (this.banner.outlineButton) {
            return {
                background: 'rgba(0, 0, 0, 0)',
                borderColor: this.banner.buttonColor,
                color: this.banner.buttonColor,
            };
        }

        return {
            background: this.banner.buttonColor,
            borderColor: this.banner.buttonColor,
            color: this.banner.contentColor,
        };
    }
}
